const NS = 'WoolLabMySwatchesBlock';
const CLS = 'woolLabMySwatchesBlock';
const CLS_MB_ACTIVE = 'is-active';

import Handlebars from 'handlebars';
import { param } from 'jquery';
import { WoolLabSwatchBlock } from './woolLabSwatchBlock';
import {WoolLabShareSwatchModalBlock} from './woolLabShareSwatchModalBlock';
import utils from '../utils';
import { forEach, identity } from 'lodash';


export class WoolLabMySwatchesBlock {

	constructor(el) {
		this.$el = $(el);

		this.$filterKeys = this.$el.find(`[data-filter-key]`);
		this.$filterDropdown = this.$el.find(`.${CLS}-filters-dropdown`);
		this.$filterDropdownBtn = this.$el.find(`.${CLS}-filters-dropdown-btn`);
		this.$fabricSwatches = this.$el.find(`.${CLS}-swatches`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.$loadMoreSpinner = this.$el.find(`.${CLS}-loadMore-spinner`);
		this.fabricSwatches = [];
		this.$searchInp = this.$el.find(`.${CLS}-searchInput`);
		this.$refineFilterBtn = this.$el.find(`.${CLS}-filterToggle.btnRefine`);
		this.$clearFilterBtn = this.$el.find(`.${CLS}-filterToggle.btnClear`);
		this.$selectFilterBtn = this.$el.find(`.${CLS}-filterToggle.btnSelect`);
		this.$filterRefined = this.$el.find(`.${CLS}-searchBar-refined`);
		this.$selectBtns = this.$el.find(`.${CLS}-swatchSelect-buttons`);
		this.$season = this.$el.find(`#season`);
		this.$theme = this.$el.find(`#theme`);
		this.$certified = this.$el.find(`#certified`);
		this.$supplier = this.$el.find(`#supplier`);
		this.$country = this.$el.find(`#country`);
		this.$benefits = this.$el.find(`#benefits`);
		this.$archived = this.$el.find(`#archived`);

		this.$displayGridBtn = this.$el.find(`.${CLS}-displayTglBtn.gridBtn`);
		this.$displayListViewBtn = this.$el.find(`.${CLS}-displayTglBtn.listViewBtn`);
		this.getAllThemes = this.$el.find(`#theme`).data('allThemes');

		this.shareSwatchesApi = this.$el.data('shareSwatchesApi');
		this.removeSwatchesApi = this.$el.data('removeSwatchesApi');
		this.getSupplierInfoApi = this.$el.data('supplierInfoApi');

		this.getSwatchDetailApi = this.$el.data('swatchDetailApi');
		this.getSupplierDetailApi = this.$el.data('getSupplierDetailApi');
		this.isInMySwatchesApi = this.$el.data('isInMySwatchesApi');
		this.getSwatchesApi = this.$el.data('swatchesApi');
		this.getFiltersApi = this.$el.data('filtersApi');
		this.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.createMoodboardApi = this.$el.data('createMoodboardApi');
		this.addToMoodboardApi = this.$el.data('addToMoodboardApi');
		this.isStudent= this.$el.data('isstudent');

		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);
		this.loadingSwatches = false;
		this.allSwatchesLoaded = false;

		this.$swatchBlock = [];

		this.$removePanel = this.$el.find(`.${CLS}-swatchSelect-removePanel`);
		this.$removePanelRemoveBtn = this.$el.find(`.${CLS}-swatchSelect-removePanel-remove`);
		this.$removePanelCancelBtn = this.$el.find(`.${CLS}-swatchSelect-removePanel-cancel`);

		this.selectedSwatchIds = [];
		this.$swatchSelectPanel = this.$el.find(`.${CLS}-swatchSelect-panel`);
		this.$swatchSelectCount = this.$el.find(`.${CLS}-swatchSelect-text-count`);
		this.$swatchSelectClearBtn = this.$el.find(`.${CLS}-swatchSelect-clear-btn`);

		this.$swatchSelectGetSupplierBtn = this.$el.find(`.${CLS}-swatchSelect-getSupplier`);
		this.$swatchSelectShareBtn = this.$el.find(`.${CLS}-swatchSelect-share`);
		this.$swatchSelectRemoveBtn = this.$el.find(`.${CLS}-swatchSelect-remove`);

		this.$swatchSelectSaveBtn = this.$el.find(`.${CLS}-swatchSelect-save-btn`);

		this.pageSize = 30;
		this.pageNumber = 1;

		var url_string = window.location.href; 
		var url = new URL(url_string);
		this.$urlkeyword = url.searchParams.get("keyword");
		this.$urltheme = url.searchParams.get("theme");
		this.$urlseason = url.searchParams.get("season");
		this.$urlcertified = url.searchParams.get("certified");
		this.$urlcountry = url.searchParams.get("country");
		this.$urlsupplier = url.searchParams.get("supplier");
		this.$urlbenefits = url.searchParams.get("benefits");
		this.$urlarchived = url.searchParams.get("archived");
		//this.$urlcolour = url.searchParams.get("colour");
		//this.$urlweight = url.searchParams.get("weight");
		//this.$urlcharacteristic = url.searchParams.get("characteristic");

		this.initParams();
		$('.selectpicker').selectpicker('destroy').selectpicker();
		this.handleDisplayToggleButtons();
		this.handleSearchInput();
		this.handleFilterToggleBtn(this.getAllThemes);
		this.handleSavePanelBtns();
		this.handleRemovePanelBtns();
		this.handlePanelBtnsVisibility();
		this.handleScrollLoading();
		this.getFilters(false);
		this.getItems(false);
		this.initFilterKeys();

		this.initFeatureFlags();

	}

	initParams(){
		this.params = {
			// siteId: this.siteId,
			count: this.pageSize,
			offset: 0,
			// pageSize: this.pageSize,
			// keyword: this.$searchInp.val() || ''
			keyword: this.$urlkeyword || '',
			theme: this.$urltheme || '',
			season: this.$urlseason || '',
			certified: this.$urlcertified || '',
			country: this.$urlcountry || '',
			supplier: this.$urlsupplier || '',
			benefits: this.$urlbenefits || '',
			archived: this.$urlarchived || 'false'
			//colour: this.$urlcolour || '',
			//weight: this.$urlweight || '',
			//characteristic: this.$urlcharacteristic || ''
		};
	}


	getWoolLabSwatchBlockTemplate() {
		let woolLabSwatchBlock = require('../../partials/widgets/woolLabSwatchBlock.hbs');

		Handlebars.registerPartial('woolLabSwatchBlock', woolLabSwatchBlock);

		let template = `
			{{> woolLabSwatchBlock
				wg="woolLabSwatchBlock"
				ns="WoolLabSwatchBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	getFilters(archived){
		let url = this.getFiltersApi;
		if (!_.isEmpty(this.params)) {
			Object.keys(this.params).forEach((key, index) => {
				if(key === "archived"){
					url = utils.updateQueryStringParameter(url, key, this.params[key]);
				}
			});
		}
		this.updateUrl();
			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					if(archived != false){
						this.$season.empty();
						this.$theme.empty();
						this.$certified.empty();
						this.$supplier.empty();
						this.$country.empty();
						this.$benefits.empty();
					}
					if (data.length > 0) {
						data.forEach((item) => {
							if(item.name == "season" && item.options){
								item.seasonOptions.forEach((options) => {
									if(this.$urlseason !== null){
										if(this.$urlseason.includes(options.name)){
											this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options.name+`'">`+options.name+`</option>`);
										}
										else{
											this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options.name+`'">`+options.name+`</option>`);
										}	
									}
									else{
										this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options.name+`'">`+options.name+`</option>`);
									}
								});
							}
							if(item.name == "theme" && item.options){
								item.options.forEach((options) => {
									if(this.$urltheme !== null){
										if(this.$urltheme.includes(options)){
											this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "certified" && item.options){
								item.options.forEach((options) => {
									if(this.$urlcertified !== null){
										if(this.$urlcertified.includes(options)){
											this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "country" && item.options){
								item.options.forEach((options) => {
									if(this.$urlcountry !== null){
										if(this.$urlcountry.includes(options)){
											this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "benefits" && item.options){
								item.options.forEach((options) => {
									if(this.$urlbenefits !== null){
										if(this.$urlbenefits.includes(options)){
											this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "supplier" && item.options){
								item.options.forEach((options) => {
									if(this.$urlsupplier !== null){
										if(this.$urlsupplier.includes(options)){
											this.$supplier.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$supplier.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$supplier.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
						});
					}
					if(archived != false){
						this.params.season = '';
						this.params.theme = '';
						this.params.certified = '';
						this.params.country = '';
						this.params.benefits = '';
						this.params.supplier = '';
					}
					this.selectpickerRefresh();
				},
				error: (error) => {
					console.log(error);
				},
				complete: () => {
					console.log("complete");
					this.loadingSwatches = false;
				},
			});
	}

	selectpickerRefresh(){
		this.$theme.selectpicker('refresh');
		this.$season.selectpicker('refresh');
		this.$certified.selectpicker('refresh');
		this.$country.selectpicker('refresh');
		this.$benefits.selectpicker('refresh');
		this.$supplier.selectpicker('refresh');
	}
	// Get items (reload content)
	getItems(loadMoreSwatches) {
		if($(this.$searchResultsEmpty).hasClass("active")){
            loadMoreSwatches = false;
			$(this.$loadingScreen).hide();
        }
		if (!this.loadingSwatches && (!this.allSwatchesLoaded || !loadMoreSwatches)) {
			this.loadingSwatches = true;

			let url = this.getSwatchesApi;

			if (loadMoreSwatches) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}
			if (!_.isEmpty(this.params)) {
				Object.keys(this.params).forEach((key, index) => {
					url = utils.updateQueryStringParameter(url, key, encodeURIComponent(this.params[key]));
				});
			}

			this.updateUrl();

			fetch(`${this.isStudent}`, {
				method: 'GET',
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				this.isStudentValue = _json;
			}).catch((_error) => { });

			return $.ajax({
				type: 'GET',
				url: url,
				success: (data) => {

					this.$searchResultsEmpty.hide();

					if (!loadMoreSwatches) {
						this.$fabricSwatches.empty();
					}

					let fabricSwatchMarkup = (markup) => {
						return `
							<div class="${CLS}-swatch">
								${(markup)}
							</div>`;
					};

					if (data.length > 0) {
						data.forEach((item) => {
							// item.userName = this.username;
							item.getSwatchDetailApi = this.getSwatchDetailApi;
							item.getSupplierDetailApi = this.getSupplierDetailApi;
							item.isInMySwatchesApi = this.isInMySwatchesApi;
							item.getMoodboardsApi = this.getMoodboardsApi;
							item.addToMoodboardApi = this.addToMoodboardApi;
							item.createMoodboardApi = this.createMoodboardApi;
							item.isStudent = this.isStudent;
							let $column = this.$fabricSwatches.append(fabricSwatchMarkup(this.getWoolLabSwatchBlockTemplate()(item)));
							new WoolLabSwatchBlock($column.find(`[data-wg="WoolLabSwatchBlock"]`).last()[0], item);
						});

						this.$swatchBlock = this.$el.find('.woolLabSwatchBlock');
						this.handleSwatchBtn();
						// this.getMySwatches();

					} else {
						if (loadMoreSwatches) {
							this.allSwatchesLoaded = true;
						} else {
							this.$searchResultsEmpty.show();
							this.$searchResultsEmpty.addClass("active");
						}
					}

					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
				},
				error: (error) => {
				},
				complete: () => {
					this.loadingSwatches = false;
				},
			});
		}
		return Promise.resolve();
	}


	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;

		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateQueryStringParameter(uri, key, encodeURIComponent(this.params[key]));
		});

		// update url without reload
		window.history.pushState('', '', uri);
	}


	// Refined Filters toggle button
	handleDisplayToggleButtons() {
		this.$displayGridBtn.on('click', () => {
			if (!this.$displayGridBtn.hasClass('selected')) {
				this.$displayGridBtn.addClass('selected');
				this.$el.addClass('displayGrid');

				this.$displayListViewBtn.removeClass('selected');
				this.$el.removeClass('displayListView');
			}
		});
		this.$displayListViewBtn.on('click', () => {
			if (!this.$displayListViewBtn.hasClass('selected')) {
				this.$displayListViewBtn.addClass('selected');
				this.$el.addClass('displayListView');

				this.$displayGridBtn.removeClass('selected');
				this.$el.removeClass('displayGrid');
			}
		});
	}

	handleFilterToggleBtn(getAllThemes) {
		this.$refineFilterBtn.on('click', () => {
			if(this.$refineFilterBtn.hasClass(CLS_MB_ACTIVE)) {
				this.$refineFilterBtn.removeClass(CLS_MB_ACTIVE);
				this.$filterRefined.removeClass(CLS_MB_ACTIVE);
				this.$el.removeClass('refined-open');
			}
			else {
				this.$refineFilterBtn.addClass(CLS_MB_ACTIVE);
				this.$filterRefined.addClass(CLS_MB_ACTIVE);
				this.$el.addClass('refined-open');
			}
		});

		this.$clearFilterBtn.on('click', () => {
			this.initParams();
			this.setPageNumber(1);
			this.allSwatchesLoaded = false;
			window.scrollTo(0, 0);
			this.selectedSwatchIds = [];
			this.updateSelectedSwatchCount();
			this.selectpickerRefresh();
			this.getItems(false);
			this.$searchInp.val('');
			$(".selectpicker").selectpicker('deselectAll');
			$('#supplier').selectpicker('val', '');
			$('#certified').selectpicker('val', '');
			$('#archived').selectpicker('val', 'false');
			this.$theme.selectpicker('val', '');
			this.$season.selectpicker('val', '');
			this.$certified.selectpicker('val', '');
			this.$country.selectpicker('val', '');
			this.$benefits.selectpicker('val', '');
		});
		this.$selectFilterBtn.on('click', () => {
			if(this.$selectFilterBtn.hasClass(CLS_MB_ACTIVE)) {
				this.$selectFilterBtn.removeClass(CLS_MB_ACTIVE);
				this.selectedSwatchIds = [];
				this.$swatchBlock.removeClass('selected')
				this.updateSelectedSwatchCount();
				this.$swatchSelectRemoveBtn.css('display', 'none');
				this.$swatchSelectGetSupplierBtn.css('display', 'none');
				this.$selectBtns.append('<button class="woolLabMySwatchesBlock-swatchSelect-getSupplier-btn btn btn--rounded" disabled>Get Supplier Info</button>');
				this.$selectBtns.append('<button class="woolLabMySwatchesBlock-swatchSelect-remove-btn btn btn--rounded" disabled>Remove</button>');	
			}
			else {
				this.$selectFilterBtn.addClass(CLS_MB_ACTIVE);
				this.params.count = 1000;
				this.getItems(true)
				.then(() => {
					this.selectedSwatchIds = [];
					this.$swatchBlock.addClass('selected');
					for (let swatch of this.$swatchBlock){
							this.selectedSwatchIds.push($(swatch).attr('data-id'));
					}
					this.updateSelectedSwatchCount();

					// Now reset params to normal page size
					this.params.count = this.pageSize;
				});
				this.$swatchSelectRemoveBtn.css('display', 'block');
				this.$swatchSelectGetSupplierBtn.css('display', 'block');
				$('button.woolLabMySwatchesBlock-swatchSelect-remove-btn').remove();
				$('button.woolLabMySwatchesBlock-swatchSelect-getSupplier-btn').remove();
			}
		});
	}

	initFilterKeys() {

		this.$woolLabSwatchBlock = this.$fabricSwatches.find(`[data-wg="WoolLabSwatchBlock"]`);
		this.$filterKeys.on('change', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filterKey') || '';
		//let value = $element.attr('value') || '';
		let value = [];
		value.push($element.val());
		this.$el.find(`[data-filter-key="${filterKey}"]`).removeClass('active');
		$element.addClass('active');

		if(!(_.isNil(this.params[filterKey]) && value === '')) {
			// Ensure that the filterKey does not match the current select value
			if(this.params[filterKey] !== value) {
				if(_.isNil(value) || value === '') {
					delete this.params[filterKey];
				}
				else {
					if(filterKey === "benefits"){
						value = value[0].join(";");
					}
					this.params[filterKey] = value;
				}

				this.setPageNumber(1);
				this.allSwatchesLoaded = false;
				if(filterKey === "archived"){
					this.getFilters(true);
				}
				this.getItems(false);
			}
			}
		});
	}


	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.setPageNumber(1);
				this.allSwatchesLoaded = false;
				this.getItems(false);
			}
		});
	}


	// Swatch button
	handleSwatchBtn() {
		this.$swatchBlock.off('click.addSave');
		this.$swatchBlock.on('click.addSave', (e) => {
			let $target = $(e.target);
			let $swatch = $(e.currentTarget);
			
			if ($target.hasClass('woolLabSwatchBlock-btnAddSave')) {
				// add to saved button clicked

				if ($swatch.hasClass('selected')) {
					$swatch.removeClass('selected');
					this.$selectFilterBtn.removeClass(CLS_MB_ACTIVE);

					let filteredItems = this.selectedSwatchIds.filter((item) => item !== $swatch.attr('data-id'));
					this.selectedSwatchIds = filteredItems;
					this.handlePanelBtnsVisibility();
				} else {
					// if first swatch is already saved to my swatches
					if (this.selectedSwatchIds == 0 && $swatch.attr('data-saved-myswatches') == 'true') {
						this.$swatchSelectPanel.find('[data-location="mySwatches"]').addClass('selected');
					}

					$swatch.addClass('selected');
					this.selectedSwatchIds.push($swatch.attr('data-id'));

					if (this.$swatchBlock.toArray().every((swatch) => $(swatch).hasClass('selected'))){
						this.$selectFilterBtn.addClass(CLS_MB_ACTIVE);
					}
					this.handlePanelBtnsVisibility();
				}
				this.updateSelectedSwatchCount();
			}
		});
	}

	handleScrollLoading() {

		let offsetFromBottom = 200;

		const This = this;

		$(document).on('touchmove', onScroll); // for mobile
		function onScroll() {
			if ($(window).scrollTop() + offsetFromBottom > $(document).height() - $(window).height()-400) {
				This.getItems(true);
			}
		}

		$(window).scroll(function() {
			let position = $(window).scrollTop() + offsetFromBottom;
			let bottom = $(document).height() - $(window).height();

			if ( position >= bottom ) {
			   This.getItems(true);
			}
		 });
	}


	handleSavePanelBtns() {
		this.$swatchSelectClearBtn.on('click', (e) => {
            this.resetSavePanel();
        });

		this.$swatchSelectGetSupplierBtn.on('click', (e) => {
			let url = `${this.getSupplierInfoApi}?swatchIds=${encodeURIComponent(this.selectedSwatchIds)}`;

			window.open(url, '_blank').focus();
			this.resetSavePanel();
			this.handlePanelBtnsVisibility();
		});

		this.$swatchSelectShareBtn.on('click', (e) => {
			this.displayShareSwatchModal();
		});

		this.$swatchSelectRemoveBtn.on('click', (e) => {
			this.$removePanel.addClass('active');
        });
	}

	handleRemovePanelBtns() {
		this.$removePanelRemoveBtn.on('click', (e) => {
			let url = `${this.removeSwatchesApi}`;
			let data = JSON.stringify(this.selectedSwatchIds);

			this.$loadingScreen.addClass('active');
			this.$removePanel.removeClass('active');
			this.resetSavePanel();


			fetch(url, {
				method: 'POST',
				dataType: 'json',
				body: data
			}).then((response) => {
				this.$loadingScreen.removeClass('active');
				this.setPageNumber(1);
				this.getItems(false);
				return response.json();
			}).then((_json) => {
			}).catch((_error) => {
			});
		});

		this.$removePanelCancelBtn.on('click', (e) => {
			this.$removePanel.removeClass('active');
        });
	}

	handlePanelBtnsVisibility() {
		if (this.selectedSwatchIds.length == 0){
			this.$swatchSelectRemoveBtn.css('display', 'none');
			this.$swatchSelectGetSupplierBtn.css('display', 'none');
			this.$selectBtns.append('<button class="woolLabMySwatchesBlock-swatchSelect-getSupplier-btn btn btn--rounded" disabled>Get Supplier Info</button>');
			this.$selectBtns.append('<button class="woolLabMySwatchesBlock-swatchSelect-remove-btn btn btn--rounded" disabled>Remove</button>');
		}
		else{
			if(this.isStudentValue === true)
			{
			this.$swatchSelectRemoveBtn.css('display', 'block');
			this.$swatchSelectGetSupplierBtn.css('display', 'none');
			$('button.woolLabMySwatchesBlock-swatchSelect-remove-btn').remove();
			$('button.woolLabMySwatchesBlock-swatchSelect-getSupplier-btn').remove();
			$('#supplier').css('display', 'none');
			}
			else
			{
			this.$swatchSelectRemoveBtn.css('display', 'block');
			this.$swatchSelectGetSupplierBtn.css('display', 'block');
			$('button.woolLabMySwatchesBlock-swatchSelect-remove-btn').remove();
			$('button.woolLabMySwatchesBlock-swatchSelect-getSupplier-btn').remove();
			}
			
		}
		if (!this.shareSwatchesApi){
			this.$swatchSelectShareBtn.remove();
		}		
	}

	resetSavePanel() {
		this.selectedSwatchIds = [];
		this.$swatchBlock.removeClass('selected');
		this.$selectFilterBtn.removeClass(CLS_MB_ACTIVE);
		this.updateSelectedSwatchCount();
	}


    updateSelectedSwatchCount() {
		this.$swatchSelectCount.html(this.selectedSwatchIds.length + (this.selectedSwatchIds.length == 1 ? ' swatch' : ' swatches'));
		// for hide and show the supplier bar, hide the function for now.
        /*if (this.selectedSwatchIds.length > 0 ) {
			this.$swatchSelectPanel.addClass('active');
        } else {
			this.$swatchSelectPanel.removeClass('active');
        }*/
    }


	getShareSwatchModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabShareSwatchModalBlock.hbs');

		Handlebars.registerPartial('woolLabShareSwatchModalBlock', modalWidget);

		let template = `
			{{> woolLabShareSwatchModalBlock
				wg="woolLabShareSwatchModalBlock"
				ns="WoolLabShareSwatchModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displayShareSwatchModal() {
		$(document.body).append(this.getShareSwatchModalTemplate()(this.data));
		let $modal = $('#woolLabShareSwatchModalBlock');

		let modalData = {};
		modalData.shareSwatchesApi = this.shareSwatchesApi;
		modalData.selectedSwatchIds = this.selectedSwatchIds;

		new WoolLabShareSwatchModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.params.count;
	}
}
